import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Tab } from '@odin-labs/components';
import { RoutedTabsPage } from './RoutedTabsPage';

export type RoutedTabsPagesProps = {
  baseRoute: string;
  tabs?: Tab[];
  className?: string;
  componentProps?: any;
};

type TabPageProps = Pick<RoutedTabsPagesProps, 'componentProps'>;

export const ScrollSpyTabsPagesContainerId = 'scrollSpyTabsPages';

export function ScrollSpyTabsPages(
  props: React.PropsWithChildren<RoutedTabsPagesProps>,
): React.ReactElement {
  const { baseRoute, tabs, className, children, componentProps } = props;

  const getTabPages = (): React.ReactElement[] =>
    tabs
      ?.filter((tab) => tab.component)
      ?.map((tab) => (
        <RoutedTabsPage
          key={tab.name}
          exact
          path={tab.path}
          component={tab.component}
          componentProps={{ tab, ...componentProps }}
        />
      ));

  const childrenWithComponentProps =
    children &&
    React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement<TabPageProps>(child, { componentProps });
      }
      return child;
    });

  return (
    <div id={ScrollSpyTabsPagesContainerId} className={className}>
      {childrenWithComponentProps ?? getTabPages()}
      <Route path={`${baseRoute}/?*?`}>
        <Redirect to={baseRoute} />
      </Route>
    </div>
  );
}
